import { render } from "./AndroidAppFile.vue?vue&type=template&id=ee077d54&scoped=true&ts=true"
import script from "./AndroidAppFile.vue?vue&type=script&lang=ts"
export * from "./AndroidAppFile.vue?vue&type=script&lang=ts"

import "./AndroidAppFile.vue?vue&type=style&index=0&id=ee077d54&scoped=true&lang=css"
import "./AndroidAppFile.vue?vue&type=style&index=1&id=ee077d54&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee077d54"]])

export default __exports__